import { TabPanelProps, TabPanel as RACTabPanel } from "react-aria-components";

export default function TabPanel(props: TabPanelProps) {
  return <RACTabPanel {...props} />;
}
